import React from "react";
import {
  Button,
  Card,
  CardBody,
  Progress,
  Modal,
  ModalFooter,
  ModalHeader,
  ModalBody
} from "reactstrap";
import NotificationSystem from "react-notification-system";
import { connect } from "react-redux";
import { alertActions, commonActions } from "../../_actions";
import { appConstants } from "../../_constants";
import { apiActions } from "../../_actions/api.actions";
import { commonService } from "../../_services";

//Page content util
import PageLoading from "../utils/page.loading";
import PageError from "../utils/page.error";
import PageEmptyContent from "../utils/page.empty-content";
import MatchedRecords from "./matched-records";
//Icons
//  import PaymentIcon from 'react-icons/lib/md/payment';
import MatchPaymentPanel from "./match-payment-panel";
import MatchedRecordPanel from "./matched-panel";

import { appHelpers, store } from "../../_helpers";

import CheckIcon from "react-icons/lib/md/info";

const ViewContent = ({ children }) => (
  <div className="view-content view-components">{children}</div>
);

class MatchedPaymentViewContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      matchedPayments: [],
      activeReconciliation: null,
      modal: false,
      modalClass: "",
      //page error
      contentError: false, //Errors that affect content on the page
      componentError: false, //Errors generated within the component
      componentErrorMessages: [], //Errors generated within the component form
      error: false, //Error state mutable via Redux
      success: false, //Success message mutable via Redux
      InvoiceDate: new Date(),
      FileId: "",
      processFiles: [],

      //    Notification
      notification: {
        // title: 'Default Title',
        message: "Default Message",
        level: "success",
        position: "tr",
        dismissible: true
      },
      currentPage: 1,
      pageSize: 10,
      totalMatchPaymentsCount: 0,
      confirmMatchPaymentEntityTypeId: null,
      unMatchedAirline: "",
      unMatchedInvoiceDate: new Date(),
      unMatchedInvoiceAmount: null
    };

    this._notificationSystem = null;
    this._lastNotificationAdded = null;
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
    const reduxState = store.getState();
    let { entities } = reduxState;
    const { dispatch } = this.props;

    if (!entities) {
      dispatch(commonActions.getEntities());
    } else {
      this.setEntityTypes(entities);
    }

    this.getInvoiceReconciliationFiles();
    const queryString = window.location.href.split("/");
    this.getReconciliationById(queryString[queryString.length - 1]);
  }

  componentWillReceiveProps = function(nextProps) {
    const { entities } = nextProps;
    if (entities) {
      this.setEntityTypes(entities);
    }
  };

  setEntityTypes = entities => {
    let confirmMatchPaymentEntityTypeId;

    entities.forEach(entity => {
      if (entity.EntityType === appConstants.APP_ENTITIES.MATCH_PAYMENT) {
        confirmMatchPaymentEntityTypeId = entity.EntityTypeId;
      }
    });
    this.setState({ confirmMatchPaymentEntityTypeId });
  };

  toggleModal = () => {
    this.setState({ modal: !this.state.modal });
  };

  handleChange = (targetValue, attribute) => {
    let currState = this.state;
    currState[attribute] = targetValue;
    let errorMessages = this.state.componentErrorMessages;
    errorMessages[attribute] = false;
    this.setState(currState);
    this.setState({ componentErrorMessages: errorMessages });
  };

  handleDateChange = targetValue => {
    this.setState({
      FileId: "",
      totalMatchPaymentsCount: 0,
      matchedPayments: []
    });
    this.getInvoiceReconciliationFiles(targetValue);
  };

  handleSelectChange = (payload, attribute) => {
    let currState = this.state;
    let errorMessages = this.state.componentErrorMessages;
    errorMessages[attribute] = false;
    currState[attribute] = payload ? payload[attribute] : ""; //Cater for setting up data and clearing data
    if (!payload) {
      currState[attribute] = "";
    } else {
      currState[attribute] = payload.FileId;
    }
    this.setState(currState);
    this.setState({ componentErrorMessages: errorMessages });
    this.fetchMatchingPayment(1);
  };

  notify = (message, level) => {
    let notification = this.state.notification;
    notification["message"] = message;
    notification["level"] = level;
    notification.onRemove = this.onRemove;
    this._lastNotificationAdded = this._notificationSystem.addNotification(
      notification
    );
  };

  onRemove = notification => {
    if (
      this._lastNotificationAdded &&
      notification.uid === this._lastNotificationAdded.uid
    ) {
      this._lastNotificationAdded = null;
    }
  };

  fetchMatchingPayment = pageNumber => {
    const { FileId, activeReconciliation } = this.state;
    const { dispatch } = this.props;
    let { pageSize } = this.state;
    let fromIndex;
    if (pageNumber === undefined) {
      dispatch(apiActions.startFullPageRequest());
      fromIndex = 0;
      pageNumber = 1;
    } else {
      fromIndex = pageSize * (pageNumber - 1);
      dispatch(apiActions.startRequest());
    }
    let payload = { PageSize: 10, From: fromIndex };
    payload.Parameter = {
      FileId: FileId,
      LocationCode: activeReconciliation.AccountCode,
      Currency: activeReconciliation.Currency,
      BilledAmount: activeReconciliation.NetAmountCurrency
    };

    commonService.getMatchingPayments(payload).then(res => {
      if (res.status === appConstants.SUCCESS_RESPONSE) {
        this.setState({
          currentPage: pageNumber,
          matchedPayments: res.response.Results,
          totalMatchPaymentsCount: res.response.TotalCount
        });
        dispatch(apiActions.endRequest());
      } else if (res.status === appConstants.ERROR_RESPONSE) {
        dispatch(alertActions.error(res.response));
        dispatch(apiActions.endRequest());
      }
    });
  };
  matchPaymentAction = item => {
    this.setState({
      billedDetailsId: item.Id,
      unMatchedAirline: item.LegacyCode,
      unMatchedInvoiceDate: appHelpers.formatDate(item.InvoiceDate),
      unMatchedInvoiceAmount: `${String.fromCharCode(
        appHelpers.getCurrencyUnicode(item.InvoiceCurrency)
      )}${appHelpers.numberWithCommas(item.NetAmountCurrency)}`
    });
    this.toggleModal();

    /*let { dispatch } = this.props;
        dispatch(apiActions.startRequest());
        commonService.processUnmatchedPayment({billedDetailsId: billedDetailsId, reconciliationId: this.state.activeReconciliation.Id})
            .then(res => {
                if(res.status === appConstants.SUCCESS_RESPONSE) {
                    this.notify('Payment matched successfully', appConstants.NOTIFY_SUCCESS);
                            dispatch(apiActions.endRequest());
                }
                else if(res.status === appConstants.ERROR_RESPONSE){
                    this.notify('Failed to match payment', appConstants.NOTIFY_ERROR);
                            dispatch(apiActions.endRequest());
                }
            });*/
  };
  confirmedMatchPaymentAction = () => {
    const userRole = appHelpers.getActiveUser().AviRole;
    const { billedDetailsId, activeReconciliation } = this.state;

    let payload = {
      billedDetailsId: billedDetailsId,
      reconciliationId: activeReconciliation.Id
    };

    if (
      userRole === appConstants.ROLES.SUPER_ADMIN ||
      userRole === appConstants.ROLES.BSP_ADMIN
    ) {
      this.processMatchPaymentAction(payload);
    } else {
      this.createMakerChecker(payload);
    }
    // commonService.processUnmatchedPayment({billedDetailsId: billedDetailsId, reconciliationId: activeReconciliation.Id})
    //     .then(res => {
    //         if(res.status === appConstants.SUCCESS_RESPONSE) {
    //             this.toggleModal();
    //             dispatch(apiActions.endRequest());
    //             this.notify('Payment matched successfully', appConstants.NOTIFY_SUCCESS);
    //             window.location.href = '/unmatched-payments';
    //          }
    //         else if(res.status === appConstants.ERROR_RESPONSE){
    //             this.toggleModal();
    //             this.notify('Failed to match payment', appConstants.NOTIFY_ERROR);
    //                     dispatch(apiActions.endRequest());
    //         }
    //     });
  };

  processMatchPaymentAction = payload => {
    let { dispatch } = this.props;

    commonService.processUnmatchedPayment(payload).then(res => {
      if (res.status === appConstants.SUCCESS_RESPONSE) {
        this.toggleModal();
        dispatch(apiActions.endRequest());
        this.notify(
          "Payment matched successfully",
          appConstants.NOTIFY_SUCCESS
        );
        window.location.href = "/unmatched-payments";
      } else if (res.status === appConstants.ERROR_RESPONSE) {
        this.toggleModal();
        this.notify("Failed to match payment", appConstants.NOTIFY_ERROR);
        dispatch(apiActions.endRequest());
      }
    });
  };

  createMakerChecker = payload => {
    const { authentication } = store.getState();
    let { dispatch } = this.props;
    const {
      confirmMatchPaymentEntityTypeId,
      unMatchedInvoiceDate,
      unMatchedAirline,
      unMatchedInvoiceAmount
    } = this.state;

    /* Maker Checker */
    let payloadTemplate = {
      UnMatchedInvoiceDate: unMatchedInvoiceDate,
      UnMatchedAirline: unMatchedAirline,
      UnMatchedInvoiceAmount: unMatchedInvoiceAmount
    };

    let makerCheckerPayload = {
      AppId: appConstants.MAKER_CHECKER_APP_ID,
      Payload: JSON.stringify(payload),
      PayloadViewTemplate: JSON.stringify(payloadTemplate),
      URL: `${
        appConstants.PAS_URL
      }/api/Payment/ProcessUnmatchedPayment?billedDetailsId=${
        payload.billedDetailsId
      }&reconciliationId=${payload.reconciliationId}`,
      EntityTypeId: confirmMatchPaymentEntityTypeId,
      CreatedBy: authentication.user.userName
    };
    dispatch(apiActions.startRequest());

    commonService.createMakerChecker(makerCheckerPayload).then(res => {
      if (res.status === appConstants.SUCCESS_RESPONSE) {
        this.toggleModal();
        let msg = "Payment confirmation sent successfully";
        this.notify(msg, appConstants.NOTIFY_SUCCESS);
        dispatch(apiActions.endRequest());
        // window.location.href = '/unmatched-payments';
      } else if (res.status === appConstants.ERROR_RESPONSE) {
        dispatch(alertActions.error(res.response));
        dispatch(apiActions.endRequest());
      }
    });
  };

  getReconciliationById = reconId => {
    commonService.getReconciliationById({ Id: reconId }).then(res => {
      if (res.status === appConstants.SUCCESS_RESPONSE) {
        if (res.response.Found) {
          this.setState({ activeReconciliation: res.response.Source });
        } else {
          this.notify("Invalid Reconciliation File", appConstants.NOTIFY_ERROR);
        }
      } else if (res.status === appConstants.ERROR_RESPONSE) {
        this.notify(res.response, appConstants.NOTIFY_ERROR);
      }
    });
  };

  getInvoiceReconciliationFiles = dateSelected => {
    let payload = { PageSize: 100, From: 0 };
    payload.Parameter =
      dateSelected === undefined
        ? {}
        : {
            InvoiceMonth: dateSelected.getMonth() + 1,
            InvoiceYear: dateSelected.getFullYear()
          };

    commonService.getInvoiceReconciliationFiles(payload).then(res => {
      if (res.status === appConstants.SUCCESS_RESPONSE) {
        this.setState({ processFiles: res.response.Results });
      } else if (res.status === appConstants.ERROR_RESPONSE) {
        this.notify(res.response, appConstants.NOTIFY_ERROR);
      }
    });
  };

  render() {
    const { requesting } = this.props;
    const { pageRequesting } = this.props;
    const {
      contentError,
      error,
      matchedPayments,
      pageSize,
      currentPage,
      totalMatchPaymentsCount,
      processFiles,
      FileId,
      InvoiceDate,
      activeReconciliation
    } = this.state;
    let matchedPaymentsLength = matchedPayments.length;
    return (
      <div className="view">
        <ViewContent>
          <Card className="mb-4">
            {/*Progress bar for Pending API Request*/}
            {(pageRequesting || requesting) && !pageRequesting && (
              <Progress
                animated
                striped
                color="success"
                value={100}
                className="mb-2"
              />
            )}

            {/*Display loader when component content is dependent on Data from API*/}
            {!contentError && pageRequesting && <PageLoading />}

            {/*Display error when component fail to get Data from API*/}
            {contentError && <PageError error={this.state.contentError} />}

            {/*Display component content when Data is gotten from API*/}
            {!contentError && !pageRequesting && (
              <CardBody className="table-responsive">
                {activeReconciliation !== null && (
                  <MatchedRecordPanel
                    activeReconciliation={activeReconciliation}
                  />
                )}
                <MatchPaymentPanel
                  processFiles={processFiles}
                  onSearch={this.fetchMatchingPayment}
                  FileId={FileId}
                  invoiceDate={InvoiceDate}
                  handleSelectChange={this.handleSelectChange}
                  handleChange={this.handleChange}
                  handleDateChange={this.handleDateChange}
                />
                {!pageRequesting && matchedPaymentsLength > 0 && (
                  <MatchedRecords
                    data={matchedPayments}
                    pageSize={pageSize}
                    currentPage={currentPage}
                    totalMatchPaymentsCount={totalMatchPaymentsCount}
                    matchCallback={this.matchPaymentAction}
                    pageDataCallBack={this.fetchMatchingPayment}
                  />
                )}

                {!pageRequesting && matchedPaymentsLength === 0 && (
                  <PageEmptyContent message="No matched payment!" />
                )}
              </CardBody>
            )}

            {/* Confirmation Modal */}
            <Modal
              size={"sm"}
              isOpen={this.state.modal}
              toggle={this.toggleModal}
              className={this.state.modalClass}
            >
              <ModalHeader toggle={this.toggleModal}>
                {" "}
                Match Payment
              </ModalHeader>
              <ModalBody>
                <div className="text-center">
                  <CheckIcon size="50" />
                </div>
                {error && (
                  <div className="alert alert-danger text-center">{error}</div>
                )}
                <h5 className="text-center mb-3">
                  Are you sure you want to match this payment?
                </h5>
              </ModalBody>
              <ModalFooter>
                <Button
                  className="btn-avi-primary"
                  disabled={requesting}
                  onClick={this.confirmedMatchPaymentAction}
                >
                  {" "}
                  Confirm{" "}
                </Button>{" "}
                <Button
                  color="secondary"
                  disabled={requesting}
                  onClick={this.toggleModal}
                >
                  {" "}
                  Cancel{" "}
                </Button>{" "}
              </ModalFooter>
              {requesting && <div className="loading-dot active">&nbsp;</div>}
            </Modal>

            <NotificationSystem ref="notificationSystem" />
          </Card>
        </ViewContent>
      </div>
    );
  }
}
function mapStateToProps(state, ownProps) {
  const { loggingIn } = state.authentication;
  const { requesting, pageRequesting } = state.api;
  const { entities } = state;
  return {
    loggingIn,
    requesting,
    pageRequesting,
    entities
  };
}
export default connect(mapStateToProps)(MatchedPaymentViewContent);



// WEBPACK FOOTER //
// ./src/views/matchPayment/view-content.js